export default __webpack_public_path__ + "static/media/Icon_User_16px.ba093dfb.svg";